const EMPLOYEE_CLIENT_STATUS = {
    READY: {
        status:'READY',
        text: 'Ready',
        color:'green'
    },
    UPDATE_REQUIRED: {
        status: 'UPDATE_REQUIRED',
        text: 'Update Required',
        color:'orange'
    },
    INACTIVE: {
        status: 'INACTIVE',
        text: 'Inactive',
        color:'violet'
    },
    DELETED: {
        status:'DELETED',
        text: 'Deleted',
        color:'red'
    },
    PENDING: {
        status: 'PENDING',
        text: 'Pending',
        color: 'yellow'
    },
};

const AUTHORIZATION_STATUS = {
    CREATED: {
        status: 'CREATED',
        text: 'Created',
        color:'blue'
    },
    PENDING: {
        status: 'PENDING',
        text: 'Pending',
        color: 'orange lighten-1'
    },
    APPROVED: {
        status: 'APPROVED',
        text: 'Approved',
        color: 'green'
    },
    EXPIRED: {
        status: 'EXPIRED',
        text: 'Expired',
        color:'red'
    },
    CANCELLED: {
        status: 'CANCELLED',
        text: 'Cancelled',
        color: 'violet'
    },
    INACTIVE: {
        status: 'INACTIVE',
        text: 'Inactive',
        color: 'pink'
    },
    USER_STATUS_ACTION: function () {
        return [this.CREATED, this.PENDING, this.APPROVED, this.CANCELLED];
    },
    USER_STATUS_NOT_ALLOW_TO_MODIFY_FORM(){
        return [this.APPROVED, this.EXPIRED, this.CANCELLED, this.INACTIVE];
    },
};

export {
    EMPLOYEE_CLIENT_STATUS,
    AUTHORIZATION_STATUS
}